const eselon2 = [{kode_kab:'0000', nama_kab:"Pusat"},
{kode_kab:2100, nama_kab:"Direktorat Sistem Informasi Statistik"},
{kode_kab:2200, nama_kab:"Biro Keuangan"},
{kode_kab:2300, nama_kab:"Biro Kepegawaian"},
{kode_kab:2400, nama_kab:"Biro Hubungan Masyarakat dan Hukum"},
{kode_kab:2500, nama_kab:"Biro Umum"},
{kode_kab:2600, nama_kab:"Pusat Pendidikan dan Pelatihan"},
{kode_kab:2700, nama_kab:"Politeknik Statistika STIS"},
{kode_kab:3100, nama_kab:"Direktorat Pengembangan Metodologi Sensus dan Survei"},
{kode_kab:3200, nama_kab:"Direktorat Diseminasi Statistik"},
{kode_kab:3300, nama_kab:"Direktorat Sistem Informasi Statistik"},
{kode_kab:3400, nama_kab:"Pejabat Fungsional"},
{kode_kab:4100, nama_kab:"Direktorat Statistik Kependudukan dan Ketenagakerjaan"},
{kode_kab:4200, nama_kab:"Direktorat Statistik Kesejahteraan Rakyat"},
{kode_kab:4300, nama_kab:"Direktorat Statistik Ketahanan Sosial"},
{kode_kab:4400, nama_kab:"Pejabat Fungsional"},
{kode_kab:5100, nama_kab:"Direktorat Statistik Tanaman Pangan00, Hortikultura00, dan Perkebunan"},
{kode_kab:5200, nama_kab:"Direktorat Statistik Peternakan00, Perikanan00, dan Kehutanan"},
{kode_kab:5300, nama_kab:"Direktorat Statistik Industri"},
{kode_kab:5400, nama_kab:"Pejabat Fungsional"},
{kode_kab:6100, nama_kab:"Direktorat Statistik Distribusi"},
{kode_kab:6200, nama_kab:"Direktorat Statistik Harga"},
{kode_kab:6300, nama_kab:"Direktorat Statistik Keuangan00, Teknologi Informasi00, dan Pariwisata"},
{kode_kab:6400, nama_kab:"Pejabat Fungsional"},
{kode_kab:7100, nama_kab:"Direktorat Neraca Produksi"},
{kode_kab:7200, nama_kab:"Direktorat Neraca Pengeluaran"},
{kode_kab:7300, nama_kab:"Direktorat Analisis dan Pengembangan Statistik"},
{kode_kab:7400, nama_kab:"Pejabat Fungsional"},
{kode_kab:8100, nama_kab:"Inspektorat Wilayah I"},
{kode_kab:8200, nama_kab:"Inspektorat Wilayah II"},
{kode_kab:8300, nama_kab:"Inspektorat Wilayah III"}]
export default eselon2;